var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10 mb-12 font-medium text-xl max-w-full w-content mx-auto px-4 sm:px-0"},[_c('h4',{staticClass:"border-b border-b-main-color"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }